import * as React from "react";
import { Link, LinkProps } from "react-router-dom";

type _InternalLinkProps = LinkProps & React.RefAttributes<HTMLAnchorElement>;
export interface InternalLinkProps extends _InternalLinkProps {
  label?: string;
  forceTargetBlank?: boolean;
}
export const InternalLink: React.FC<InternalLinkProps> = ({ forceTargetBlank, label, className, target, ...props }) => {
  if (!target && forceTargetBlank) {
    target = "_blank";
  }

  return (
    <Link className={`inline-block truncate color-link ngfocus ${className}`} {...props} target={target}>
      {label}
    </Link>
  );
};
